var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionLink',_vm._g(_vm._b({attrs:{"hierarchy":_vm.buttonHierarchy,"href":_vm.url,"data-test-id":"content-block-button"}},'ActionLink',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.buttonLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }